/**
 * 路由索引
 * 包含所有带有code属性的路由配置
 */
import { CiCircleFilled } from "@ant-design/icons";
import { history } from "@umijs/max";
export const useRou = () => {
  const menu: any = {
    base_info: {
      path: "/base-info",
      name: "基本信息",
      code: "base_info",
      icon: "database",
    },
    area: {
      path: "/base-info/area",
      name: "服务片区",
      code: "area",
      icon: "environment",
      component: "./base-info/area",
    },
    merchant: {
      path: "/base-info/customer",
      name: "商户信息",
      code: "merchant",
      icon: "user",
      component: "./base-info/customer",
    },
    operational_data: {
      path: "/base-info/operation",
      name: "运营信息",
      code: "operational_data",
      icon: "setting",
      component: "./base-info/operation",
    },
    wr_record: {
      path: "/garbage-record",
      name: "清运记录",
      code: "wr_record",
      icon: "fileText",
    },
    reminder: {
      path: "/expiration-reminder",
      name: "到期提醒",
      code: "reminder",
      icon: "bell",
      component: "./expiration-reminder",
    },
    reconcile: {
      path: "/reconciliation",
      name: "对账",
      code: "reconcile",
      icon: "AccountBookOutlined",
    },
    reconcile_list: {
      path: "/reconciliation/list",
      name: "对账列表",
      code: "reconcile_list",
      icon: "unorderedList",
      component: "./reconciliation/list",
    },
    reconcile_manual: {
      path: "/reconciliation/manual",
      name: "手动对账",
      code: "reconcile_manual",
      component: "./reconciliation/manual",
    },
    ticket: {
      path: "/invoice",
      name: "开票",
      code: "ticket",
      icon: "file",
    },
    ticket_list: {
      path: "/invoice/list",
      name: "开票列表",
      code: "ticket_list",
      icon: "container",
      component: "./invoice/list",
    },
    ticket_manual: {
      path: "/invoice/manual",
      name: "手动开票",
      code: "ticket_manual",
      icon: "form",
      component: "./invoice/manual",
    },
    received: {
      path: "/payment-collection",
      name: "回款",
      code: "received",
      icon: "transaction",
    },
    received_list: {
      path: "/payment-collection/list",
      name: "回款列表",
      code: "received_list",
      icon: "profile",
      component: "./payment-collection/list",
    },
    received_manual: {
      path: "/payment-collection/manual",
      name: "手动回款",
      code: "received_manual",
      icon: "carry",
      component: "./payment-collection/manual",
    },
    cash_received: {
      path: "/immediate-payment",
      name: "现结回款",
      code: "cash_received",
      icon: "dollarCircle",
      component: "./immediate-payment",
    },
    recharge: {
      path: "/charge",
      name: "充值",
      code: "recharge",
      icon: "wallet",
    },
    balance_reminder: {
      path: "/balance-reminder",
      name: "卡余额提醒",
      code: "balance_reminder",
      icon: "alert",
      component: "./balance-reminder",
    },
    waste_disposal: {
      path: "/absorption",
      name: "消纳",
      code: "waste_disposal",
      icon: "export",
    },
     order: {
      path: "/wasteOrder",
      name: "订单管理",
      code: "order",
      icon: "export",
    },
    data_analyse: {
      path: "/statistical",
      name: "统计分析",
      code: "data_analyse",
      icon: "barChart",
      component: "./statistical",
    },
    rule_config: {
      path: "/rule-config",
      name: "规则设置",
      code: "rule_config",
      icon: "control",
      component: "./rule-config",
    },
    system_config: {
      path: "/system-config",
      name: "系统设置",
      code: "system_config",
      icon: "tool",
    },
  };
  const getHome = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const menuList: any = JSON.parse(
          localStorage.getItem("menuList") || "[]"
        );
        let routerObj: any = null;
        if (menuList && menuList.length > 0) {
          let code: any = menuList[0].code;
          if (menuList[0].children && menuList[0].children.length > 0) {
            code = menuList[0].children[0].code;
          }
          routerObj = menu[code];
        }
        resolve(routerObj);
      }, 50);
    });
  };
  const getHasMenu = (menuReal: any) => {
    const menuList: any = JSON.parse(
      localStorage.getItem("menuList") || "[]");
    let codes: string[] = [];

    menuList.forEach((item: any) => {
      codes.push(item.code);
      if (item.children && item.children.length > 0) {
        item.children.forEach((child: any) => {
          codes.push(child.code);
        });
      }
    });

    const menuListNew = menuReal.filter((item: any) => {
      return codes.includes(item.code);
    });
    menuListNew.map((item: any) => {
      if (item.children && item.children.length > 0) {
        item.children = item.children.filter((child: any) => {
          return codes.includes(child.code) || typeof child.code == "undefined";
        });
      }
    }); 
    return menuListNew;
  };
  const logout = () => {
    localStorage.removeItem("accountToken");
    localStorage.removeItem("currentUser");
    localStorage.removeItem("menuList");
     localStorage.removeItem("sonicToken");
    history.push("/user/login");
  };
  const hasAi = ()=>{
    const menuList: any = JSON.parse(
      localStorage.getItem("menuList") || "[]");
    const aiMenu = menuList.filter((item:any)=>item.code=='ai') 
    return aiMenu.length>0;
  }
  return {
    menu,
    getHome,
    logout,
    getHasMenu,
    hasAi
  };
};
